import { NAMESPACE } from "./catalog";
import { PACK_DESCRIPTION, withUniqueIds } from "./datapack";
import type { Creation } from "./types";

export type BinaryFileMap = Record<string, Uint8Array>;

export interface TexturedCreation {
  creation: Creation;
  texture: Uint8Array | null;
}

const RESOURCE_MIN_FORMAT = 75;
const MAX_FORMAT = 999;
const HANDHELD_KINDS = ["weapon", "tool"];
const encoder = new TextEncoder();

export function buildResourcePack(input: TexturedCreation[]): BinaryFileMap {
  const ids = withUniqueIds(input.map((entry) => entry.creation));
  const files: BinaryFileMap = {
    "pack.mcmeta": json({ pack: { description: PACK_DESCRIPTION, min_format: RESOURCE_MIN_FORMAT, max_format: MAX_FORMAT } }),
  };
  input.forEach(({ texture }, i) => Object.assign(files, itemFiles(ids[i], texture)));
  return files;
}

function itemFiles(creation: Creation, texture: Uint8Array | null): BinaryFileMap {
  const id = creation.id;
  const files: BinaryFileMap = {
    [`assets/${NAMESPACE}/items/${id}.json`]: json({ model: { type: "minecraft:model", model: `${NAMESPACE}:item/${id}` } }),
  };
  if (texture) {
    const parent = HANDHELD_KINDS.includes(creation.kind) ? "minecraft:item/handheld" : "minecraft:item/generated";
    files[`assets/${NAMESPACE}/models/item/${id}.json`] = json({ parent, textures: { layer0: `${NAMESPACE}:item/${id}` } });
    files[`assets/${NAMESPACE}/textures/item/${id}.png`] = texture;
  } else {
    files[`assets/${NAMESPACE}/models/item/${id}.json`] = json({ parent: `minecraft:item/${creation.baseItem}` });
  }
  return files;
}

function json(value: unknown): Uint8Array {
  return encoder.encode(JSON.stringify(value, null, 2));
}
